import React from 'react';
import classnames from 'classnames';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
var TierThumbHtmlView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation)) },
        React.createElement("div", { className: "daeditor-freeform-header" },
            React.createElement("span", { className: "daeditor-freeform-title" }, getDeviationTitle(deviation)))));
};
TierThumbHtmlView.displayName = 'TierThumbHtmlView';
export default TierThumbHtmlView;
//# sourceMappingURL=TierHtml.js.map